import * as React from 'react';
import { connect } from 'react-redux';

import Spinner from 'components/spinner/Spinner';
import ActionButton from 'components/buttons/action-button/ActionButton';
import { ModalFrame, ModalFrameEntity, ModalFrameFooter, ModalFrameInner } from 'components/modal';

import AgencyCreatorItem from './agency-creator-item/AgencyCreatorItem';

import { fetchAgencyInfluencers } from 'modules/influencers/reducers/influencerAgencyProfiles';

import { __t, applyTranslations } from 'utils/language';

import type { InfluencerProfile, State } from 'types';
import type { AgencyProfile } from 'modules/influencers/types/AgencyProfile.type';
import { AgencyProfilesLoadingState } from 'modules/influencers/types/AgencyProfile.type';

import './agency-creators-modal.scss';

applyTranslations(require('locales/common/collabary-common.i18n.json'));
applyTranslations(require('./agency-creators-modal.i18n.json'));

type OwnProps = {
  influencerProfile: InfluencerProfile,
  agencyName: string,
  onCloseModal: () => void
};

type StateProps = {
  creators: Array<AgencyProfile>,
  loadingStatus: AgencyProfilesLoadingState
};

type DispatchProps = {
  dispatchFetchAgencyInfluencers: (profileId: number) => void
};

type Props = OwnProps & StateProps & DispatchProps;

const AgencyCreatorsModal = (
  {
    influencerProfile,
    agencyName,
    creators,
    loadingStatus,
    dispatchFetchAgencyInfluencers,
    onCloseModal
  }: Props
): JSX.Element => {
  React.useEffect(() => {
    dispatchFetchAgencyInfluencers(influencerProfile.id);
  }, [influencerProfile.id]);

  const isLoaded = loadingStatus === AgencyProfilesLoadingState.loaded;

  return (
    <ModalFrame
      title={__t('agency_creators_modal.title', { agencyName })}
    >
      <ModalFrameEntity
        influencerProfile={influencerProfile}
      />
      <ModalFrameInner minHeight={300}>
        {
          !isLoaded && (
            <Spinner
              position="inline"
              size="small"
              color="light"
            />
          )
        }
        {isLoaded && creators.length === 0 && (
          <div className="agency-creators-modals__empty-list">
            {__t('agency_creators_modal.empty_list')}
          </div>
        )}
        {
          isLoaded && creators.map(creatorProfile => (
            <AgencyCreatorItem
              key={`creatorProfile-${creatorProfile.id}`}
              creatorProfile={creatorProfile}
            />
          ))
        }
      </ModalFrameInner>
      <ModalFrameFooter>
        <ActionButton
          onClick={onCloseModal}
        >
          {__t('collabary_common.action_button.ok')}
        </ActionButton>
      </ModalFrameFooter>
    </ModalFrame>
  );
};

const mapStateToProps = ({ influencerAgencyProfiles }: State): StateProps => ({
  creators: influencerAgencyProfiles.profiles,
  loadingStatus: influencerAgencyProfiles.loadingStatus
});

const mapDispatchToProps = (dispatch) => ({
  dispatchFetchAgencyInfluencers: (profileId: number) => dispatch(fetchAgencyInfluencers(profileId))
});

export default connect(mapStateToProps, mapDispatchToProps)(AgencyCreatorsModal);
